/**
@format
@flow
*/
import React, { useEffect } from 'react';
import Amplify from 'aws-amplify';
import amplitude from 'amplitude-js';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import ActionTypes from '@ziynx/action-types';
import { createGlobalStyle } from 'styled-components';
import { AppManager, UploadManager, NotificationManager } from '@ziynx/components/utilities';
import { HelmetProvider } from 'react-helmet-async';
import { getAnalyticsConfig } from '@ziynx/analytics';
import { store, persistor } from './redux/store';
import awsconfigdev from './aws-exports.dev';
import awsconfigprod from './aws-exports.prod';
import AppRouter from './routing/AppRouter';

const isDev: boolean = process.env.REACT_APP_DEVELOPMENT === 'true';
Amplify.configure(isDev ? awsconfigdev : awsconfigprod);

/*
  In the event a react portal or extraction is being used,
  and we need to target the css
*/
const GlobalStyle = createGlobalStyle`
  [class*='_linkModal'] {
    z-index: 992;
  }
  [class*='_linkModalOverlay'] {
    z-index: 991;
  }
`;

export default function App(): React$Node {
  useEffect(() => {
    const {
      AMPLITUDE_API_KEY, analyticsEnabled,
    } = getAnalyticsConfig();

    store.dispatch({ type: ActionTypes.auth.checkIfLoggedIn.START });

    // Initialize analytics SDK
    if (analyticsEnabled) {
      store.dispatch({ type: ActionTypes.analytics.openSession.START });

      /* ----------------- AMPLITUDE ---------------- */
      amplitude.getInstance().init(AMPLITUDE_API_KEY, null, {
        onError: () => {
          // eslint-disable-next-line no-console
          console.warn('Error initializing amplitude instance');
        },
      });
    }
  }, []);

  return (
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppManager>
            <NotificationManager>
              <GlobalStyle />
              <AppRouter />
              <UploadManager />
            </NotificationManager>
          </AppManager>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  );
}
